// ----
// This is where all of the site-specific JS goes. This is the site's main JS file, so make your JS defensive.
// It's created using the JS Module Pattern (http://addyosmani.com/resources/essentialjsdesignpatterns/book/#modulepatternjavascript)
// Usage: SCM.SiteJS.functionName();  Can be used anywhere in the application.
// ----

var SCM = SCM || {};

(function (ns, $) {

    // ----
    // private variables and functions
    // ----
    var $body = $('body');
    var $filterList = $('.search-wrap-filters');
    var $fullMobileReset = false;
    var $mobileMenuOpen = false;
    var $mobileSearchOpen = false;
    var $navbarSearchContainer = $('.js-navbar-search-container');
    var $closeNavSearch = $('.js_close-navsearch');
    var $expandNavSearch = $('.js_expand-navsearch');
    var $navbarMenu = $('.navbar-menu, .navbar-search-collapsed'); // fade these in/out from 931px to 1100px
    var $navbarSearchElements = $('.navbar-search-advanced, .navbar-search-close, .navbar-search'); // fade these in/out from 931px to 1100px
    var $navbarSearchInput = $('.navbar-search .navbar-search-input');
    var $mobileSearchInput = $('.mobile-search-input');
    var $viewOption = 'Basic';

    $('#hfViewOption').val(); //Based on Client's configuration setting, set the appropriate default value.

    // ----
    // Many Pages / Global
    // ----

    // Initialize "Navigate to main content" link
    // History: NARN-17805 support site-wide banner jump point
    ns.initSkipNavToMainContent = function () {
        var bannerHash = '#skipNav_sitewidebanner';
        var $bannerNav = $(bannerHash);

        // update to link to banner if present
        // NOTE: The default #skipNav href comes from theme, not OUP
        if ($bannerNav.length) {
            $('.skipnav').attr('href', bannerHash);
        }

        $('.skipnav').on('click', function () {
            if ($bannerNav.length) { $bannerNav.focus(); }
            else { $('#skipNav').focus(); }
        });
    };

    ns.isPageViewLarge = function () {
        if ($body.hasClass('pg_ViewLarge')) {
            return true;
        }
    };

    ns.setBlockLink = function () {
        $(document).on('click', '.js-widget-dynamic-entry', function (e) {
            var destination = $(e.currentTarget).data('resource-url');
            if (destination) {
                window.location = destination;
            }
        });
    };

    ns.setAllLinksTarget = function () {
        $('a[target]').not('.openInAnotherWindow').each(function () {
            $(this).attr('target', '');
        });
    };

    ns.getNewSelectedFilter = function () {
        var $listItems = $filterList.children('li');
        $listItems.on('click', function () {
            var $this = $(this);
            $listItems.removeClass('selected');
            $this.addClass('selected');
            SCM.SiteJS.setSelectedSearchFilter();
        });
    };

    ns.getViewportWidth = function () {
        return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    };


    ns.initLazyLoad = function () {
        $('img.contentFigures, img.inlineGraphics, img.lazy').lazyload(
            { skip_invisible: false }
        );
    };

    ns.detectIfFirefox = function () {
        var FF = !(window.mozInnerScreenX == null);
        if (FF) {
            $('html').addClass('firefox');
        }
        else {
            return;
        }
    };

    ns.initFoundation = function () {
        $(document).foundation();
    };

    ns.loadAllImagesIfUserIsAboutToUseJumpLinks = function () {
        $('#LeftNavSticker').hover(function () {
            $('.lazy').each(function () {
                var $this = $(this);

                $this.attr('src', $this.attr('data-original'));
            });
        });
    };

    ns.showAuthorInfo = function () {
        const matchList = '.js-linked-name-trigger, .linked-name, .al-author-name .linked-name, .al-author-name-more .linked-name, .linked-name-byline, .al-author-footnotes .js-linked-footnotes';
        let activeTrigger = null;

        $(matchList).on('click', function (e) {
            const $targetModal = $(this).siblings('.al-author-info-wrap');
            e.stopPropagation();

            SCM.Toolbar.closeHypothesis();
            $('.al-author-info-wrap').not($targetModal).removeClass('open');
            $($targetModal).toggleClass('open');

            updateAuthorAriaExpanded($(this));
            checkAuthorCardPosition();

            if ($targetModal.hasClass('open')) {
                activeTrigger = this;
            } else {
                activeTrigger = null;
            }

            SCM.ScholarlyiQ.trackOnPageEvent('article-author-' + $(this).text());
        });

        $(document.body).on('click', function (e) {
            if (!$(e.target).parents('.al-author-info-wrap').length) {
                closeAllFlyouts();
            }
        });

        $(document).on('keydown', function (e) {
            if (e.key === 'Escape' || e.keyCode === 27) {
                if ($('.al-author-info-wrap.open').length) {
                    closeAllFlyouts(true);
                }
            }
        });

        $(document).on('focusout', '.al-author-info-wrap', function (e) {
            const $flyout = $('.al-author-info-wrap.open');
            if ($flyout.length) {
                const relatedTarget = e.relatedTarget;
                if (!relatedTarget || !$(relatedTarget).closest('.al-author-info-wrap').length) {
                    closeAllFlyouts();
                }
            }
        });

        $(document).on('focusout', matchList, function (e) {
            const $trigger = $(this);
            const relatedTarget = e.relatedTarget;
            
            const $flyout = $trigger.siblings('.al-author-info-wrap.open');
            if ($flyout.length) {
                if (!relatedTarget || 
                    (!$(relatedTarget).closest('.al-author-info-wrap').is($flyout) && 
                     !$(relatedTarget).is($trigger))) {
                    closeAllFlyouts();
                }
            }
        });        

        function closeAllFlyouts(returnFocusToTrigger = false) {
            $('.al-author-info-wrap').removeClass('open');
            $(matchList).attr('aria-expanded', false);

            if (returnFocusToTrigger && activeTrigger) {
                $(activeTrigger).focus();
            }
            activeTrigger = null;
        }
    };

    function updateAuthorAriaExpanded($trigger) {
        var flyoutId = $trigger.attr('aria-controls');
        var $flyout = $('#' + flyoutId);
        if ($flyout.length) {
            var isExpanded = $flyout.hasClass('open');
            $trigger.attr('aria-expanded', isExpanded);
        }
    }

    function checkAuthorCardPosition() {
        if ($(window).width() < 1200) {
            if ($('.al-author-info-wrap.open:visible').length && $('#ContentColumn:visible').length) {
                var $contentColumn = $('#ContentColumn');
                var columnRightEdge = $contentColumn.position().left + $contentColumn.width();
                var $authorCard = $('.al-author-info-wrap.open');
                SCM.SiteJS.shiftOpenAuthorCards($authorCard, columnRightEdge);
            }
        }
    }

    ns.addAuthorFootnote = function () {
        $('.al-author-name, .al-author-name-more').each(function () {
            var $authorNote = $(this).find('.info-card-note .xref-fn');
            if ($authorNote.length && $authorNote.text() === '*') {
                var $footNote = $('<sup/>').append($authorNote.html());
                $footNote.insertAfter($(this).find('.linked-name'));
                $authorNote.remove();
            }
            if ($(this).find('.info-author-correspondence').length) {
                $(this).find('.linked-name').append('<i class="icon-general-mail"></i>');
                $(this).find('.linked-name-byline').append('<i class="icon-general-mail"></i>');
            }
        });
    };


    ns.showHideDropDown = function () {
        $('.selectDropdown').on('click', function (e) {
            $('.dropdown').hide().removeClass('open');
            e.stopPropagation();
            $(this).siblings('.dropdown').slideToggle('300', 'linear').toggleClass('open');
        });

        $(document).click(function () {
            $('.dropdown').hide().removeClass('open');
        });
    };


    ns.showMoreRelatedContent = function (viewMoreSelector, hideMeSelector) {
        $(viewMoreSelector).click(function () {
            var $this = $(this);
            $this.closest('.related-section-box, .widget-RelatedBookContent').find(hideMeSelector).toggleClass('show-item');
            $this.toggleClass('show-less').find('i').toggleClass('icon-show').toggleClass('icon-hide');
            $this.hasClass('show-less') ? $this.find('span').text('See Less') : $this.find('span').text('See More');
        });
    };


    ns.showRelatedBookWidgetIfHasContent = function () {
        // This may (or may not) be a temporary function. We able to standardize the related book widget with the other related widgets (relatedgbos, relatedmultimedia).
        // Those widgets are such that if there is no content, a particular div is never output and so no styles appear on the page. However,
        // relatedbook widget was already being used by WK
        $('.widget-RelatedBookContent').each(function () {
            var $this = $(this);

            if ($this.find('*').length > 5) {
                $this.addClass('show');
            }
        });
    };


    // Just for Books, look for anchor objects containing ISBN, these are unresolved links)   
    // See NARN-14328. Do not route to EndMatter Page for related objects with end-notes. See NARN-11737
    ns.handleUnresolvedRelatedObjectLinks = function () {
        // Pssst: If you change this code, you might also want to change the default platform code in scm.relatedobjectlinks.js. - JG 2020.

        $(document).on('click', 'a[isbn][object-type!="end-note"], .js-link-page', function () {
            // default redirect to 404 page
            var redirectUrl = '/CustomError?statusCode=404';

            // get link properties
            var link = $(this);
            var isbn = link.attr('isbn');
            var bookId = $('#bookId').val();
            var legacySectionId = link.attr('legacySectionId');
            var $relatedObj = $('div[name="' + legacySectionId + '"]');

            if (popupParagraphStyleBibliography(link, legacySectionId)) {
                return;
            }

            // If it's on this page, don't need to find the related objecct on the server side
            if ($relatedObj.length) {
                window.location.hash = legacySectionId;
                return;
            }
            isbn = isbn === null || isbn === undefined ? '' : isbn.trim();
            legacySectionId = legacySectionId === null || legacySectionId === undefined ? '' : legacySectionId.trim();

            // Is there an ISBN we can use?
            if (isbn !== '' || legacySectionId !== '') {

                var baseUrl = App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '';
                $.ajax({
                    url: baseUrl + '/Book/GoToRelatedObjectLink',
                    cache: true,
                    dataType: 'json',
                    data: {
                        isbn: isbn,
                        legacySectionId: legacySectionId,
                        currentBookId: bookId
                    },
                })
                    .done(function (response) {
                        if (response && response.Success) {
                            window.top.location.assign(response.RedirectURL);
                        }
                        else {
                            // if it failed, go to 404 page
                            window.top.location.assign(redirectUrl);
                        }
                    })
                    .fail(function () {
                        window.top.location.assign(redirectUrl);
                    });

            }
            else {
                window.top.location.assign(redirectUrl);
            }
        });
    };

    function popupParagraphStyleBibliography(link, legacySectionId) {
        if (link.hasClass('js-link-other')) {
            var $revealObj = $('div[content-id="' + legacySectionId + '"]');
            if ($revealObj.length) {
                var $revealContent;
                // We don't have an identifier for paragraph style bibliography.
                // If xref type is other and the reference object is in a "mixed - citation" we consider this as a paragraph style bibliography.
                if ($revealObj.parents('.mixed-citation').length) {
                    $revealContent = $revealObj.parents('.js-paragraph-ref').first();
                    // definition list terms
                } else if ($revealObj.parents('.def-item').length) {
                    $revealContent = $revealObj.parents('.def-item').first();
                }
                if ($revealContent) {
                    revealModal(legacySectionId, $revealContent);
                    return true;
                }
            }
        }

        return false;
    }


    ns.showSpinner = function () {
        function spinner() {
            $('.preloader-wrap').removeClass('hide').addClass('active');
        }

        SCM.QueryBuilder.defaults.beforeSearch = spinner;
        $('.pagination').on('click', spinner);
    };


    ns.setSelectedSearchFilter = function () {
        var selected = $filterList.children('.selected').text();
        $('.selected-text').text(selected);
    };


    ns.initFilterClickEvent = function () {
        $('.filter-wrap').on('click', function (e) {
            $filterList.hide();
            e.stopPropagation();
            $filterList.toggle();
        });

        $(document).click(function () {
            $filterList.hide();
        });
    };

    ns.launchSupersededContentModal = function () {
        $('#supersededContent').on('opened.fndtn.reveal', function () {
            $('.js-latest-link').focus();
        });
        $('#supersededContent').on('closed.fndtn.reveal', function () {
            $(document.body).focus();
        });
        $('#supersededContent').foundation('reveal', 'open');
    };

    ns.launchAddAlertModal = function () {
        $('[data-reveal-id="addArticleUpdateAlert"]').click(function () {
            $('#AddAlert').foundation('reveal-modal', 'open');
        });
    };
    ns.launchEmailUserModal = function () {
        $('[data-reveal-id="emailUsernameModal"]').click(function () {
            $('#emailUserName').foundation('reveal-modal', 'open');
        });
    };

    ns.showFullDisclaimer = function () {
        $(document).on('click', '.disclaimer-text', function () {
            $(this).closest('.disclaimer-text').find('.js-disclaimer').toggleClass('hide');
        });
    };

    ns.showFullVersionInfo = function () {
        $('.js-version-info-more-link').on('click', function () {
            $(this).closest('.version-info-text').find('.js-version-info').toggleClass('hide');
        });
    };

    // ----
    // START: Mobile Site Nav & Search
    // ----


    /**********************************************************************
    * Close expanded navbar search between 931px and 1100px
    **********************************************************************/
    ns.closeNavbarSearch = function () {
        $closeNavSearch.on('click', function () {
            $navbarSearchContainer.removeClass('tablet-viewport-active');
            $navbarSearchElements.hide();
            $navbarMenu.fadeIn();
        });
    };

    /**********************************************************************
     * Expands hidden navbar search between 931px and 1100px
     **********************************************************************/
    ns.expandNavbarSearch = function () {
        $expandNavSearch.on('click', function () {
            $navbarSearchContainer.addClass('tablet-viewport-active');
            $navbarMenu.hide();
            $navbarSearchElements.fadeIn(); // fade in
            $navbarSearchInput.focus(); // move focus to the input
        });
    };


    ns.calculateResetState = function ($otherMenuState) {
        $otherMenuState ? $fullMobileReset = true : $fullMobileReset = false;
        SCM.SiteJS.resetMobileSiteNav($fullMobileReset);
    };


    ns.toggleMobileLanguageSubmenu = function () {
        $('.mobile-header-language').on('click', function () {
            $('.mobile-language-submenu').slideToggle();
        });
    };

    ns.toggleMobileSignInForm = function () {
        var $mobileLogin = $('.mobile-login'),
            $mobileSigninNavArrow = $('.mobile-signin-nav-arrow');

        // The mobile login form works a little differently - can't have it toggle closed when the li is clicked
        $('.mobile-menu-link-wrap').on('click', function () {
            if (!$mobileLogin.hasClass('open')) {
                $mobileLogin.addClass('open').slideToggle();
                $mobileSigninNavArrow.hide();
                //$thisArrow.removeClass('icon-general_arrow-right').addClass('icon-general_arrow-down');
            }
        });

        // close button for mobile login form
        $('.site-menu .mobile-login-form').on('click', '.mobile-login-icon', function () {
            $mobileLogin.removeClass('open').slideToggle();
            $mobileSigninNavArrow.show();
        });
    };


    ns.resetMobileSearchFilters = function () {
        $('.sf-facets, .sf-facet-list').removeAttr('style');
        $('.sf-group-header-icon').removeClass('icon-general_arrow-down').addClass('icon-general_arrow-right');
    };

    ns.resetMobileSiteNav = function ($fullReset) {
        // for Global Header
        $('.header-bottom, .navigation, .microsite-search, .arrow-nav, .arrow-search, .mobile-language-submenu').removeAttr('style');
        $('.mobile-search-toggle, .mobile-menu-toggle, .arrow-nav, .arrow-search').removeClass('active');
        $('.microsite-search').removeClass('active-tablet');
        if ($fullReset) {
            // if $fullReset == true, user scrolled or resized
            $mobileMenuOpen = false;
            $mobileSearchOpen = false;
            // otherwise, we're just toggling between mobile menu items
        }
    };


    ns.toggleMobileSearch = function () {
        $('.mobile-search-toggle').on('click', function () {
            SCM.SiteJS.calculateResetState($mobileMenuOpen, $mobileSearchOpen);
            $mobileSearchOpen === false ? $mobileSearchOpen = true : $mobileSearchOpen = false;
            SCM.SiteJS.toggleResponsiveMenus($('.mobile-search-toggle, .arrow-search'), $mobileSearchOpen, $('.microsite-search'));
        });
    };


    // ----
    // START: Responsive Left Column
    // ----
    ns.toggleResponsiveLeftColumn = function () {
        var $pageColLeft = $('.page-column--left');
        var closeBtn = $('.toggle-left-col__close');
        var lastActiveElement;
        var tabbableTaxonomyLabel = $('.page-column--left .js-taxonomy-label');

        tabbableTaxonomyLabel.keypress(function (e) {
            var key = e.which;
            if (key === 13)  // the enter key code
            {
                this.click();
            }
        });

        $(document.body).removeClass('noscroll'); // remove if page reloads as a result of a filter being selected

        $('.js-main').on('click', '.toggle-left-col__search, .toggle-left-col__article', function (e) {
            e.preventDefault();
            lastActiveElement = document.activeElement;
            $(document.body).addClass('noscroll');
            $pageColLeft.show().addClass('js-filters-open');
            var modal = $('.page-column--left .info-inner-wrap');
            modal.attr('tabindex', '-1').focus();

            SCM.trapFocus.publicTrapFocus(modal, closeBtn, lastActiveElement);
            if (!navigator.userAgent.toLowerCase().includes('mozilla')) {
                $(document).on('touchmove', function (e) {
                    e.preventDefault();
                });
            }

            $(document).ajaxComplete(function () {
                $(document.body).removeClass('noscroll');
                $pageColLeft.removeClass('js-filters-open');
                $(document).off('touchmove');
                ns.initFoundation();
            });
        });


        // due to designs, Issue has a different mobile layout
        $('.toggle-left-col__issue').on('click', function (e) {
            e.preventDefault();
            $(document.body).addClass('noscroll');
            $('.issue-dropdown-wrap').hide();
            $('.responsive-issue-nav').show();
            if (!navigator.userAgent.toLowerCase().includes('mozilla')) {
                $(document).on('touchmove', function (e) {
                    e.preventDefault();
                });
            }
        });


        closeBtn.on('click', function (e) {

            e.preventDefault();
            $(document.body).removeClass('noscroll');
            $pageColLeft.removeClass('js-filters-open');
            $('.page-column--left, .responsive-issue-nav, .issue-dropdown-wrap').removeAttr('style');
            $(document).off('touchmove');
            ns.initFoundation(); // reactivate sticky/topbar
        });
    };

    // ----
    // END: Responsive Left Column
    // ----



    ns.toggleMobileMenu = function () {
        $('.mobile-menu-toggle').on('click', function () {
            SCM.SiteJS.calculateResetState($mobileSearchOpen, $mobileMenuOpen);
            $mobileMenuOpen === false ? $mobileMenuOpen = true : $mobileMenuOpen = false;
            SCM.SiteJS.toggleResponsiveMenus($('.mobile-menu-toggle, .arrow-nav'), $mobileMenuOpen, $('.navigation'));
        });
    };


    ns.toggleResponsiveMenus = function ($makeActive, $openState, $classesToToggle) {
        var $headerBottom = $('.header-bottom');
        if ($openState) {
            // open responsive menu
            $makeActive.addClass('active');
            $classesToToggle.show();
            $headerBottom.slideToggle();
        } else {
            // close responsive menu
            $makeActive.removeClass('active');
            $headerBottom.toggle();
            $classesToToggle.delay(50).hide();
            // make sure menu is hidden before contents inside disappear
        }
    };

    // ----
    // END: Mobile Site Nav & Search
    // ----

    // ----
    // END: Mobile Article Navigation
    // ----


    // ----
    // Content Pages
    // ----

    ns.showFullAuthorList = function () {
        var $showMoreLink = $('.meta-authors--etal');
        var $remainingAuthors = $('.meta-authors--remaining');
        var $limitedAuthors = $('.meta-authors--limited');
        var $hiddenDelimiter = $limitedAuthors.find('.delimiter-hidden');

        $showMoreLink.on('click', function (e) {
            e.preventDefault();
            $showMoreLink.removeClass('is-active');
            $showMoreLink.attr('aria-hidden', true);
            $remainingAuthors.addClass('is-active');
            $remainingAuthors.attr('aria-hidden', false);

            if ($hiddenDelimiter) {
                $hiddenDelimiter.removeClass('delimiter-hidden');
                $hiddenDelimiter.addClass('delimiter');
            }

        });
    };

    // lazy load is triggered by scroll. If we append this content into a modal -- it might not appear.
    // This forces the images to appear
    ns.showImages = function ($obj) {
        $obj.find('.contentFigures').each(function () {
            var elem = $(this);
            if (elem.attr('src').toLowerCase().indexOf('grey.gif') >= 0) {
                elem.attr('src', elem.attr('data-original'));
            }
        });
    };


    // There is generic modal div wrapper in site.master where we append any content that needs to be put in a modal
    ns.openRevealModal = function ($obj) {
        var $modal = $('#revealModal');
        $modal.find('#revealContent').empty().prepend($obj.contents().clone());
        $modal.foundation('reveal', 'open');
        SCM.SiteJS.showImages($modal);
        SCM.SiteJS.restrictedImages();

        //save last focus to return after modal closes
        var lastFocusedElement = document.activeElement;
        //change focus to modal that is receiving class of open
        $(document).on('opened.fndtn.reveal', '[data-reveal]', function () {
            $('.open').focus();
            $('.open').addClass('at-openModal');
            SCM.trapFocus.publicTrapFocus($modal, $modal.find('.close-reveal-modal'), lastFocusedElement);
        });
        //return focus to previous location
        $(document).on('close.fndtn.reveal', '[data-reveal]', function () {
            $modal.removeClass('at-openModal');
        });
    };


    ns.revealFigsTablesInModal = function () {
        var modalTriggerElems = '.xref-bibr, .xref-fn, .link-reveal, .table-graphic, .caption-title';

        $body.on('click', modalTriggerElems, function () {
            var $this = $(this);
            var revealId = $this.attr('reveal-id')
                ? $this.attr('reveal-id')
                : $this.attr('data-reveal-id') ? $this.attr('data-reveal-id') : $this.attr('data-id');

            var revealContent = findContent(revealId);
            revealContent = revealContent.length ? revealContent : $('[content-id="' + revealId.toLowerCase() + '"]').first();
            revealModal(revealId, revealContent);
        });

    };

    function findContent(revealId) {
        var revealContent = $('[content-id="' + revealId + '"]').first();
        // special case for table groups
        if (!revealContent.length) {
            var $tableGroupSpan = $('[id="' + revealId + '"]').first();
            if ($tableGroupSpan.length) {
                var tableId = $tableGroupSpan.next().attr('id');
                revealContent = $('[data-statsid="' + tableId + '"]');
            } else {
                $tableGroupSpan = $('[data-table-id="' + revealId + '"]').first();
                if ($tableGroupSpan.length) {
                    revealContent = $tableGroupSpan.find('.table-wrap');
                }
            }
        }
        return revealContent;
    }

    function revealModal(revealId, revealContent) {
        var needSubscriptionModal = $('#NeedSubscription');
        // Handle range of references. Ex: (7-10)
        if (revealId.length && !revealContent.length) {
            var revealIdArray = revealId.split(' ');
            if (revealIdArray.length >= 2) {
                var rangeContent = $('<div/>');
                var startItem = revealIdArray[0];
                var endItem = revealIdArray[revealIdArray.length - 1];

                var rangeRevealContent = $('[content-id="' + startItem + '"]').first();
                rangeRevealContent = rangeRevealContent.length ? rangeRevealContent : $('[content-id="' + startItem.toLowerCase() + '"]').first();
                if (rangeRevealContent.length) {
                    rangeContent.append(rangeRevealContent.children().clone());
                    rangeContent = ns.getAllReferencesInRange(rangeRevealContent, rangeContent, endItem);
                }
                revealContent = rangeContent.html().length > 0 ? rangeContent : '';
            }
        }

        // Brightcove HTML5 player doesn't work with cloned content
        if ($(revealContent).hasClass('video-modal') || $(revealContent).hasClass('audio-modal')) {
            revealContent.foundation('reveal', 'open');
        }
        else {
            // Found the figure or table? Open it in reveal modal. Otherwise, you must not have access to the content and
            // we'll show you the need account message.
            revealContent.length ? SCM.SiteJS.openRevealModal(revealContent) : needSubscriptionModal.foundation('reveal', 'open');

        }
    }

    ns.revealFeaturedFigureInModal = function () {
        $('.issue-featured-image a').on('click', function () {
            //clone the HTML then replace small image url with regular size image url
            var revealContent = $(this).closest('.image-synopsis-wrap').html();
            var $modal = $('#revealModal');
            var $closeBtn = $modal.find('.js-close-reveal-modal');
            var featuredfigureurl = $(this).data('featuredfigureurl');
            if (featuredfigureurl) {
                $modal.find('#revealContent').empty().prepend(revealContent);
                $('#revealContent img').attr('src', featuredfigureurl);
                $modal.foundation('reveal', 'open');
                var $focused = $(':focus');
                // set focus to modal on open, reset back to currently focused item on modal close
                $modal.off('opened.fndtn.reveal');
                $modal.on('opened.fndtn.reveal', function () {
                    $('.close-reveal-modal').focus();
                    SCM.trapFocus.publicTrapFocus($modal, $closeBtn, $focused);
                });
                $modal.on('closed.fndtn.reveal', function () {
                    $focused.focus();
                    $modal.off('keydown.SCM.trapFocus');
                    $(this).find('#revealContent').empty();
                });

            }
        });
    };


    ns.getAllReferencesInRange = function (elem, content, endValue) {
        var nextElem = elem.next();
        var revealId = nextElem.attr('content-id');
        if (revealId.length) {
            content.append(nextElem.children().clone());
            var endRange = revealId === endValue || revealId === endValue.toLowerCase();
            if (!endRange) {
                ns.getAllReferencesInRange(nextElem, content, endValue);
            }
        }
        return content;
    };


    ns.showUnAuthenticatedSpans = function () {
        // For un-authenticated users, replace reveal-modal links with spans, since target of link is 99.99% likely to be missing
        $(document).ready(function () {
            var hasAccess = $('div[data-widgetname="ArticleFulltext"] span#UserHasAccess').attr('data-userHasAccess');
            if (hasAccess && hasAccess.length && hasAccess.toLowerCase() === 'false') {
                var revealModalLinks = $('div[data-widgetname="ArticleFulltext"] a[data-reveal-id]');
                revealModalLinks.each(function () {
                    $(this).replaceWith(function () {
                        var anchorHtml = this.innerHTML;
                        return '<span>' + anchorHtml + '</span>';
                    });
                });
            }
        });
        // TODO: OP: implement for book chapters too
    };

    // ----
    // START: Site Header
    // ----

    // Mobile Nav Dropdowns
    ns.oupHeaderDropdowns = function () {

        $('.mobile-search-toggle').on('click', function (e) {
            e.preventDefault();
            var $thisParameter = $(this);

            SCM.SiteJS.manageMobileDropdowns($thisParameter, '.mobile-search-dropdown');
        });

        $('.mobile-account-toggle').on('click', function (e) {
            e.preventDefault();
            var $thisParameter = $(this);

            SCM.SiteJS.manageMobileDropdowns($thisParameter, '.mobile-account-dropdown');
        });

        $('.mobile-nav-toggle').on('click', function (e) {
            e.preventDefault();
            var $thisParameter = $(this);

            SCM.SiteJS.manageMobileDropdowns($thisParameter, '.mobile-nav-dropdown');
        });
    };

    ns.manageMobileDropdowns = function (thisObject, dropdownClass) {

        if ($('.dropdown-panel').hasClass('is-active')) {
            // a panel is already active
            if (thisObject.hasClass('is-active')) {
                // the clicked panel is already active - slideToggle to close it
                $(dropdownClass).slideToggle().removeClass('is-active');
                thisObject.removeClass('is-active');
                thisObject.attr('aria-expanded', 'false');
                //return focus to the toggle
                $('.mobile-search-toggle').focus();
            } else {
                // a different panel is activated ...
                $('.mobile-dropdown-toggle').removeClass('is-active').attr('aria-expanded', 'false');
                $('.dropdown-panel-wrap').children('.is-active').slideToggle().removeClass('is-active');
                // ... and open this one
                thisObject.addClass('is-active');
                thisObject.attr('aria-expanded', 'true');
                $(dropdownClass).delay(400).slideToggle().addClass('is-active');
            }
        } else {
            // no panels were open - make this one active
            thisObject.addClass('is-active');
            thisObject.attr('aria-expanded', 'true');
            $(dropdownClass).slideToggle().addClass('is-active');
            $mobileSearchInput.focus(); //give focus to the input
        }

    };

    //Login constants to indicate which source login form initiated login activity
    var SourceSignIn = 'signin';
    var SourceMobile = 'mobile';
    var SourceDesktop = 'desktop';
    var signInLoaded = false;

    ns.initSigninForm = function () {
        var $mobileSignInLink = $('.mobile-account-dropdown ul li .mobile-account-signin'),
            $mobileSignInArrow = $('.mobile-account-dropdown ul li i.mobile-nav-arrow'),
            $desktopSignInForm = $('.dropdown-panel-signin'),
            $desktopInstitution = $('.dropdown-panel-institution');

        var loadSignInForm = function (source) {

            $desktopSignInForm.toggleClass('active').toggle();

            if (signInLoaded) {
                return;
            }

            var loginUrl = SCM.SiteJS.GetLoginUrl(source);
            var captchaInstNum = SCM.SiteJS.GetCaptchaInstanceNumber(source);
            // Get the login form markup with AJAX
            $.ajax({
                url: (App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '') + loginUrl,
                cache: false,
                data: {
                    captchaInstanceNumber: captchaInstNum
                },
                success: function (data) {
                    // Insert markup into appropriate desktop or mobile panels
                    SCM.SiteJS.UpdateLoginForm(source, data);
                    SCM.AddReturnUrlToSocietyLinks();
                    signInLoaded = true;
                }
            });
        };

        //DESKTOP signin from dropdown
        $('.oup-header-menu-item.desktop .dropdown-toggle.signin').on('click', function (e) {
            e.preventDefault();
            loadSignInForm(SourceDesktop);
        });

        //DESKTOP institution dropdown
        $('.dropdown-toggle.institution').on('click', function (e) {
            e.preventDefault();
            $desktopInstitution.toggleClass('active').toggle();
        });

        var clickStartedOutsideLoginBox = false;
        $(document).mousedown(function (e) {
            var hideOnClick = $('.dropdown-panel-signin, .dropdown-panel-institution');

            clickStartedOutsideLoginBox = !$(hideOnClick).is(e.target) // if the target of the click isn't the container...
                && $(hideOnClick).has(e.target).length === 0;           // ... nor a descendant of the container
        });

        // close the desktop signin form if clicking outside of it
        $(document).mouseup(function (e) {

            var hideOnClick = $('.dropdown-panel-signin, .dropdown-panel-institution');

            if (clickStartedOutsideLoginBox && !$(hideOnClick).is(e.target) // if the target of the click isn't the container...
                && $(hideOnClick).has(e.target).length === 0) // ... nor a descendant of the container
            {
                $(hideOnClick).hide();
                hideOnClick.removeClass('active');
            }

            clickStartedOutsideLoginBox = false;
        });

        //MOBILE signin form
        $mobileSignInLink.on('click', function (e) {
            e.preventDefault();

            loadSignInForm(SourceMobile);

            $mobileSignInArrow.hasClass('icon-general_arrow-down') ? $mobileSignInArrow.removeClass('icon-general_arrow-down').addClass('icon-general_arrow-up') : $mobileSignInArrow.removeClass('icon-general_arrow-up').addClass('icon-general_arrow-down');
            $mobileSignInLink.toggleClass('active');
        });


        // button login
        $(document).on('click', '.signin-form .signin-button', function (e) {
            var $closestSigninForm = $(this).closest('.signin-form'),
                $closestSpinner = $closestSigninForm.find('.preloader-wrap');
            e.preventDefault();
            e.stopPropagation();

            SCM.SiteJS.Login($closestSigninForm, $closestSpinner);

            if (location.pathname !== '/sign-in') {
                SCM.ScholarlyiQ.trackOnPageEvent('site-signin');
            }
        });

        // Enter key login
        $(document).on('keypress', '.signin-form input.username, .signin-form input.password', function (e) {
            var $closestSigninForm = $(this).closest('.signin-form'),
                $closestSpinner = $closestSigninForm.find('.preloader-wrap');
            var code = e.keyCode || e.which;
            if (code === 13) {
                e.preventDefault();
                SCM.SiteJS.Login($closestSigninForm, $closestSpinner);
            }
        });

        // Log Out
        $('.signout-button').off('click');
        $(document).on('click', '.signout-button', function () {
            var returnUrl;

            // certain pages requires login
            if (location.pathname.toLowerCase().indexOf('/my-account') === 0) {
                returnUrl = '/';
            }
            else {
                returnUrl = location.pathname + location.search;
            }

            $.get('/LOGOUT', { dest: '/HTTPHandlers/SAMs/LogoutHandler.ashx' })
                .done(function () {
                    window.top.location.assign(returnUrl);
                }).fail(function () {
                    //temporary fix for shibboleth error
                    window.top.location.assign(returnUrl);
                });

            SCM.ScholarlyiQ.trackOnPageEvent('site-signout');
        });

        // Shibboleth login
        $(document).on('click', 'a.shibboleth-signin', function () {
            var currLocation = window.top.location;
            var shibbolethHandlerUrl = currLocation.origin + '/SHIBBOLETH?dest=' + encodeURIComponent(currLocation.pathname + currLocation.search);
            var shibbolethUrl = $(this).data('target').replace('{0}', encodeURIComponent(shibbolethHandlerUrl));

            window.top.location = shibbolethUrl;
        });

    };

    ns.initLoginFormDropdown = function () {
        $('.signin-form').on('click', 'a[data-target="register"]', function (e) {
            e.preventDefault();

            var returnUrl = SCM.JSUtility.getSearchParamByName('returnUrl');
            if (returnUrl === undefined || returnUrl === null) {
                returnUrl = location.pathname + location.search;
            }

            window.top.location.assign('/my-account/register?returnUrl=' + encodeURIComponent(returnUrl));
        });
    };

    /* Note:  loginInstanceName referenced in the html input element is setup in the LoginForm
     * widget and if changed here will need to be changed in that widget as well.  The input
     * element is used to designate which login form captcha element on a page with multiple 
     * login forms is accessed by the user */
    ns.Login = function ($formContainer, $formSpinner) {

        var username = $formContainer.find('input.username').val();
        var password = $formContainer.find('input.password').val();
        var honeypotValue = $formContainer.find('#hpcName').val();

        if (honeypotValue.length > 0 && console.warn) {
            console.warn('Honeypot captcha triggered. Are you a bot?');
            return;
        }

        if (username.length === 0 || password.length === 0) {
            $formContainer.find('.error').show();
            return;
        }

        var simpleCaptchaEnabled = $('.js-captcha-simple').length > 0;
        var normalCaptchaEnabled = $formContainer.find('.js-captcha-normal').length > 0;
        var source = $formContainer.find('input.loginInstanceName').val();
        $formSpinner.removeClass('hide');
        var captchaInstanceId = 0;
        var simpleCaptchaIdName = 'txtCaptchaInputId';
        if (normalCaptchaEnabled) {
            switch (source) {
                case SourceSignIn:
                    captchaInstanceId = captcha0;
                    break;
                case SourceMobile:
                    captchaInstanceId = captcha1;
                    break;
                case SourceDesktop:
                    captchaInstanceId = captcha2;
                    break;
                default:
                    captchaInstanceId = 0;
                    break;
            }
        }
        else if (simpleCaptchaEnabled) {
            simpleCaptchaIdName += '-' + SCM.SiteJS.GetCaptchaInstanceNumber(source).toString();
        }
        $.post((App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '') + '/OUP/ValidateCaptcha',
            {
                captchaResponse: normalCaptchaEnabled ? grecaptcha.getResponse(captchaInstanceId) : '',
                simpleCaptchaResponse: simpleCaptchaEnabled ? document.getElementById(simpleCaptchaIdName).value : '',
                captchaInstanceNumber: SCM.SiteJS.GetCaptchaInstanceNumber(source)
            })
            .done(function (result) {
                if (result === '1') {
                    $.post('/LOGIN', { user: username, pass: password, dest: '/HTTPHandlers/SAMs/LoginHandler.ashx' })
                        .done(function (result) {
                            if (result === '1') {
                                if (location.pathname.toLowerCase() === '/sign-in' && SCM.JSUtility.getSearchParamByName('handoff_url')) { // Rievent SSO
                                    window.location.reload(); // the reload will trigger the redirect
                                }
                                else {
                                    SCM.SiteJS.loginReturnBack();
                                }
                            }
                            else {
                                $.post('/OUP/LoginFormIncrementFailedAttempts')
                                    .done(function () {
                                        var loginUrl = SCM.SiteJS.GetLoginUrl(source);
                                        var captchaInstNum = SCM.SiteJS.GetCaptchaInstanceNumber(source);
                                        $.ajax({
                                            url: (App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '') + loginUrl,
                                            cache: false,
                                            data: {
                                                captchaInstanceNumber: captchaInstNum
                                            },
                                            success: function (data) {
                                                SCM.SiteJS.UpdateLoginForm(source, data);
                                                SCM.AddReturnUrlToSocietyLinks();
                                                $('.error').show();
                                                $formSpinner.addClass('hide');
                                            }
                                        });
                                    });
                            }
                        });
                }
                else {
                    var loginUrl = SCM.SiteJS.GetLoginUrl(source);
                    var captchaInstNum = SCM.SiteJS.GetCaptchaInstanceNumber(source);
                    $.ajax({
                        url: (App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '') + loginUrl,
                        cache: false,
                        data: {
                            captchaInstanceNumber: captchaInstNum
                        },
                        success: function (data) {
                            SCM.SiteJS.UpdateLoginForm(source, data);
                            SCM.AddReturnUrlToSocietyLinks();
                            $('.error').show();
                            $formSpinner.addClass('hide');
                        }
                    });
                }
            });
    };

    ns.UpdateLoginForm = function (source, data) {

        // Insert markup into sign-in form that initiated the sign-in operation
        var normalCaptchaEnabled = false;
        if (source === SourceDesktop) {
            var $desktopSignInElement = $('.dropdown-panel-signin');
            $desktopSignInElement.html(data);
            // set the source value into the html hidden input so source can be detected when submitting
            $desktopSignInElement.find('input.loginInstanceName').val(SourceDesktop);
            /* Note:  the suffix -lf in register-captcha-text-normal-lf is hardcoded in LoginForm widget
             * so any changes here need a corresponding change in that widget */
            normalCaptchaEnabled = $desktopSignInElement.find('div.register-captcha-text-normal-lf').length > 0;
            if (normalCaptchaEnabled) {
                resetCaptchaElement2();
            }
        }
        else if (source === SourceMobile) {
            var $mobileSignInElement = $('.mobile-account-dropdown ul li ul.individual-menu');
            $mobileSignInElement.html(data);
            $mobileSignInElement.find('input.loginInstanceName').val(SourceMobile);
            normalCaptchaEnabled = $mobileSignInElement.find('div.register-captcha-text-normal-lf').length > 0;
            if (normalCaptchaEnabled) {
                resetCaptchaElement1();
            }
        }
        else if (source === SourceSignIn) {
            var $signInElement = $('.unauth-column.account');
            $signInElement.html(data);
            $signInElement.find('input.loginInstanceName').val(SourceSignIn);
            normalCaptchaEnabled = $signInElement.find('div.register-captcha-text-normal-lf').length > 0;
            if (normalCaptchaEnabled) {
                resetCaptchaElement();
            }
        }
    };

    ns.GetLoginUrl = function (source) {
        var loginUrl = '/OUP/LoginForm/LoginFormPopup';
        // Sign-in uses default configuration wherea other login forms use LoginFormPopup instance configuration
        if (source == SourceSignIn) {
            loginUrl = '/OUP/LoginForm/OUP_SignInPage_LoginForm';
        }
        return loginUrl;
    };

    ns.GetCaptchaInstanceNumber = function (source) {
        var captchaInstNum = 0;
        switch (source) {
            case SourceSignIn:
                captchaInstNum = 0;
                break;
            case SourceMobile:
                captchaInstNum = 1;
                break;
            case SourceDesktop:
                captchaInstNum = 2;
                break;
            default:
                captchaInstNum = 0;
                break;
        }
        return captchaInstNum;
    };

    ns.loginReturnBack = function () {
        var returnUrl = SCM.JSUtility.getSearchParamByName('returnUrl');

        if (returnUrl === undefined || returnUrl === null) {
            returnUrl = SCM.JSUtility.getSearchParamByName('redirectUrl'); // for backward compatibility
        }

        // by default come back / refresh current page
        if (returnUrl === undefined || returnUrl === null || returnUrl === '') {
            returnUrl = window.top.location.pathname + window.top.location.search;
        }

        returnUrl = decodeURIComponent(returnUrl);

        // exclude URLs which can only be accessed before sign-in
        var regex = /^\/((\w+\/)?sign-in|my-account\/forgot-password|my-account\/reset-password|my-account\/register)/i;
        if (regex.test(returnUrl)) {
            returnUrl = '/';
        }

        else if (/^\/[^\/]+/.test(returnUrl)) {
            // do nothing to the return url
        }     // check for a domain that we can validate

        // Special case for secureacademic.oup.com NARN-13051 HOTFIX
        else if (returnUrl.indexOf('secureacademic.oup.com') < 0) {
            // match a (candidate) domain name preceded by two slashes.
            // See the RFC 1738 (URL) and RFC 3492 (Punycode).  We observe a less strict format for our diagnostic.

            var returnDomainTest = returnUrl.match(/\/\/([^/]+(?:\.[^./]+)*)/i);
            if (returnDomainTest === null) {
                // NARN-5928: sanitize if no match for the known format
                returnUrl = '/';
            }
            else {
                // otherwise, make sure the domain matches our current domain
                var returnHostnameLower = returnDomainTest[1].toLowerCase();
                var windowHostname = window.top.location.hostname.toLowerCase();
                if (returnHostnameLower !== windowHostname) {
                    returnUrl = '/';
                }
                else {
                    // accept the URL with the same domain
                }
            }
        }


        // only allow same domain
        if (returnUrl !== '/' && returnUrl.indexOf('secureacademic.oup.com') < 0) {
            var returnDomainTest = returnUrl.match(/\/\/([^/]+\.)?([^./]+\.[^./]+)/i);
            if (returnDomainTest !== null && returnDomainTest[2].toLowerCase() !== window.top.location.hostname.match(/(.*\.)?([^.]+\.[^.]+)/i)[2].toLowerCase()) {
                returnUrl = '/';
            }
        }

        window.top.location.assign(returnUrl);
    };

    ns.showErrorMessage = function (main, messageDiv) {
        main.find('.js-message').hide();
        messageDiv.removeClass('hide');
        messageDiv.show();
    };

    ns.processTaxonomies = function (taxonomies) {
        var list = new Array();
        for (var i = 0; i < taxonomies.length; i++) {
            var taxonomy = taxonomies[i];
            var id = taxonomy.attributes['data-id'].value;
            list.push(id);
        }

        return list;
    };

    // ----
    // Search Results
    // ----
    ns.initSearchResultsSort = function () {
        var $sortOrderSelectOption = $('.sort-order-select-option'),
            $sortOrderSelect = $('.sort-order-select'),
            $preloaderWrap = $('.preloader-wrap');

        // Adding .off to avoid multiple bindings here - this function 
        // is called after on an AjaxComplete event
        // SolrSearch is done with ajax.  Don't want to avoid calling it all together
        // in case it's needed for something else
        $sortOrderSelect.off('change').on('change', function () {
            var qs = $(this).val();
            SCM.SearchResults.doSolrSearch({ queryString: qs, source: 'searchresults' });
        }); // END sortOrderSelect.on('change')

        $sortOrderSelectOption.off('click').on('click', function () {
            var lnk = $(this).find('option[value]');
            if (lnk.length) {
                $preloaderWrap.removeClass('hide');
            }
            // save selected sort order & details state to sessionStorage
            sessionStorage.detailsState = $viewOption;
        }); // END sortOrderListItem.on('click')

        $('.al-pageNumber,.sr-nav-previous,.sr-nav-next').off('click').on('click', function () {
            if (!$(this).hasClass('currentPage')) {
                $preloaderWrap.removeClass('hide');
                var url = $(this).attr('data-url');
                SCM.SearchResults.doSolrSearch({ queryString: url });
            }
        });
    };

    // Disable rightclick on figure context for restricted images.
    ns.restrictedImages = function () {
        $('div.graphic-wrap[restricted]').each(function () {
            var copyrightMessage = $(this).children('.copy-right-statement');
            $(copyrightMessage).toggle(false);
            $(this).off('contextmenu').on('contextmenu', function () { // right click
                $(copyrightMessage).toggle();
                return false;
            });
            $(this).off('click').click(function () { // left click on link around image
                $(copyrightMessage).toggle();
                return false;
            });
            $(copyrightMessage).off('click').click(function () { // left click on copyright message
                $(copyrightMessage).toggle();
                return false;
            });
        });
    };

    SCM.ArticleListNewAndPopular.registerArticleListNewAndPopularCombinedMode();

    // move submitcomment link.
    ns.moveSubmitCommentLink = function () {
        var $placeHolderSubmitComment = $('.submitCommentPlaceHolder');
        var $userComment = $('.widget-UserComment');
        $placeHolderSubmitComment.append($userComment);
    };

    // add user comment jumplink into article left nav
    ns.addUserCommentJumpLink = function () {
        var $articleLeftNav = $('.content-nav');
        if ($articleLeftNav.length) {
            var $jumplink = $('.comments-jumplink');
            $articleLeftNav.append($jumplink);
        }
    };


    // NARN-11152 support relocating and displaying special jump links even if section jump links are not present
    var relocateJumpLinks = function ($jumpLinks) {
        if ($jumpLinks.length) {
            // make sure the article contents title is visible
            $('.contents-title').show();

            // relocate the jump links
            // NOTE: the article left navigation element should always be present.
            var $articleLeftNav = $('.jumplink-list');
            $articleLeftNav.append($jumpLinks);
        }
    };

    ns.addDataSupplementsJumpLink = function () {
        var $dataSupplements = $('.dataSupplements-jumplink'); // typically in .widget-ArticleDataSupplements
        relocateJumpLinks($dataSupplements);
    };
    ns.addDataRepositoriesJumpLink = function () {
        var $dataRepos = $('.dataRepositories-jumplink'); // typically in .widget-ArticleDataRepositories
        relocateJumpLinks($dataRepos);
    };
    ns.addAuthorNotesJumpLink = function () {
        var $authorNotesTitle = $('.authorNotes-section-title');
        if ($authorNotesTitle.length) {
            var $authorLink = $(
                '<li class="section-jump-link head-1"><div class="section-jump-link__link-wrap">' +
                '<a class="jumplink js-jumplink scrollTo" href="#authorNotesSectionTitle">' + $authorNotesTitle.text() +
                '</a></div></li>'
            );
            relocateJumpLinks($authorLink);
        }
    };

    ns.shiftOpenAuthorCards = function (authorCard, columnRightEdge) {
        var $authorLinkWrap = authorCard.closest('.al-author-name');
        if (!$authorLinkWrap.length) {
            $authorLinkWrap = authorCard.closest('.al-author-name-more');
        }
        var linkPos = $authorLinkWrap.offset();
        var cardWidth = authorCard.width();
        var authorCardRight = linkPos.left + cardWidth;
        if (authorCardRight > columnRightEdge) {
            authorCard.addClass('shift-card');
        } else if (authorCard.hasClass('shift-card') && linkPos.left + cardWidth < columnRightEdge) {
            authorCard.removeClass('shift-card');
        }
    };

    ns.toggleSearchResultsDetails = function () {

        var $switchContainer = $('#switch-container'),
            $switchPost = $('#switch-post'),
            $expandedView = $('.sri-expandedView');

        // Determine display setting
        if (sessionStorage.detailsState) {
            $viewOption = sessionStorage.detailsState;
        } else {
            if (typeof clientViewOption !== 'undefined' && clientViewOption !== '') {
                $viewOption = clientViewOption;
            } else {
                $viewOption = $('#hfViewOption').val(); //Based on Client's configuration setting, set the appropriate default value.
            }
        }

        // Adjust DOM elements based on display setting
        if ($viewOption === 'Expanded') {
            $switchContainer.removeClass('off').addClass('on');
            $switchPost.removeClass('off').addClass('on');
            $expandedView.removeClass('hide');
        } else if ($viewOption === 'Basic') {
            $expandedView.addClass('hide');
        }

        // Save current display setting when clicking a pagination link
        $('.pagination').on('click', function () {
            if (typeof Storage !== 'undefined') {
                sessionStorage.detailsState = $viewOption;
            } else {
                sessionStorage.detailsState = $viewOption;
            }
        });

        // Change toggle button & display setting when it's clicked
        $switchContainer.off('click').on('click', function (e) {
            e.stopPropagation();
            $viewOption === 'Expanded' ? $viewOption = 'Basic' : $viewOption = 'Expanded';
            $switchContainer.toggleClass('on off');
            $switchPost.toggleClass('on off');
            $expandedView.hasClass('hide') ? $expandedView.removeClass('hide') : $expandedView.addClass('hide');
        });
    };

    var isFinishedAdjustRelatedTagsDisplay = false;
    ns.adjustRelatedTagsDisplay = function () {
        // step 1: create a variable for each type/row of tags (Keywords, Topic, Subject, etc)
        $('.article-metadata-panel:not(.solr-resource-metadata):not(:last)').remove();
        var $articleMetadataPanel = $('.article-metadata-panel:not(.solr-resource-metadata)').last(),
            $keywordGroupSection = $('.kwd-group'), //output through XSLT template <kwd-group>
            $relatedTopicTags = $('.related-topic-tags'),
            $taxonomies = $('.article-metadata-taxonomies'),
            $tocSections = $('.article-metadata-tocSections'),
            $editor = $('.wi-editors'),
            $openScienceBadge = $('.wi-open-science-badge'),
            $taggedCollections = $('.metadata-taggedCollection');

        // step 2: put those variables into an array
        var $tagContainerArray = [
            $keywordGroupSection,
            $relatedTopicTags,
            $taxonomies,
            $tocSections,
            $editor,
            $openScienceBadge,
            $taggedCollections
        ];
        if (!$articleMetadataPanel.length) {
            // no abstract, use the standalone metadata panel
            $articleMetadataPanel = $('.article-metadata-standalone-panel');
            // make sure the standalone panel isn't empty before showing

            // NARN-7484: Position metadata-panel before main article text
            $('.widget-items').prepend($articleMetadataPanel);
        }

        // NARN-23391: Add gift access panel after article metadata panel if it exists
        var $giftAccessPanel = $('.gift-access-panel');
        if ($giftAccessPanel.length && $articleMetadataPanel.length) {
            $articleMetadataPanel.after($giftAccessPanel);
        }

        // step 3: cycle through $tagContainerArray 
        for (var i = 0; i < $tagContainerArray.length; i++) {
            // step 3b: if current item has content, append to $articleMetadataPanel
            if ($tagContainerArray[i].length) {
                $articleMetadataPanel.append($tagContainerArray[i]);
            }
        }

        if ($articleMetadataPanel.html()) {
            $articleMetadataPanel.show();
        }

        // remove empty metadata panels (client requirement)
        ns.removeEmpty('.article-metadata-panel');
        ns.removeEmpty('.article-metadata-standalone-panel');
        ns.removeEmpty('.access-state-logos');
        ns.removeEmpty('.article-pubstate');

        isFinishedAdjustRelatedTagsDisplay = true;
        window.dispatchEvent(new CustomEvent('adjustRelatedTagsDisplay.complete'));
    };

    ns.isFinishedAdjustRelatedTagsDisplay = function () { return isFinishedAdjustRelatedTagsDisplay; };

    ns.removeEmpty = function (selector) {
        var $elements = $(selector);
        for (var i = 0; i < $elements.length; i++) {
            var $element = $elements.eq(i);
            if ($element.children().length === 0) {
                var text = $element.text();
                if (!text || !text.trim()) {
                    $element.remove();
                }
            }
        }
    };

    ns.showPdfOnlyLink = function () {
        if ($('.PdfOnlyLink').length && $('.toolbar-item.item-pdf').length) {
            var $innerPdfOnly = $('.PdfOnlyLink').children();
            var $newLink = $('.toolbar-item.item-pdf').children().clone();
            $newLink.html($innerPdfOnly);
            $newLink.appendTo('.PdfOnlyLink');
        }
    };

    ns.triggerSaveSearchModelOnRedirect = function () {
        var saveSearch = SCM.JSUtility.getParamFromHash('triggerSaveSearch');
        if (saveSearch === '1') {
            $('.lnkSaveSolrSearch').trigger('click');
            SCM.JSUtility.removeParamFromHash('triggerSaveSearch');
        }
    };

    // ----
    // START: Acessibility Functions (ARIA)
    // ----

    ns.ariaToggleTable = function (ariaTarget) {
        var $ariaControl = $(ariaTarget + '-button'),
            $ariaIcon = $ariaControl.children('.collapse-icon');

        $ariaControl.on('click', function (e) {
            e.preventDefault();
            //toggle aria-expanded attribute
            $ariaControl.attr('aria-expanded') === 'true' ? $ariaControl.attr('aria-expanded', 'false') : $ariaControl.attr('aria-expanded', 'true');
            // toggle arrow
            $ariaIcon.hasClass('icon-general-arrow-filled-down') ? $ariaIcon.removeClass('icon-general-arrow-filled-down').addClass('icon-general-arrow-filled-right') : $ariaIcon.removeClass('icon-general-arrow-filled-right').addClass('icon-general-arrow-filled-down');
            //toggle active class & state on the target table to show/hide it
            $(ariaTarget).toggleClass('hide');
            $(ariaTarget).attr('aria-hidden') === 'false' ? $(ariaTarget).attr('aria-hidden', 'true') : $(ariaTarget).attr('aria-hidden', 'false');
        });
    };

    ns.initAriaControls = function () {
        //tables on: academic.oupdev.silverchair.com/[JOURNAL]/subscribe/SingleIssue & CurrentYear
        var $tables = $('[id^=collapsible-table-]');
        $tables.each(function (index) {
            SCM.SiteJS.ariaToggleTable('#collapsible-table-' + index);
        });
    };

    // ----
    // START: Issue Page: ArticleListAccess.cshtml
    // ----
    ns.abstractMathJax = function () {
        if ($('.js-abstract-response-placeholder').length) {
            MathJax.typesetPromise(['.abstract-response-placeholder'])
                .catch((err) => console.error(err.message));
        }
    };

    // ----
    // End: Issue Page: ArticleListAccess.cshtml
    // ----

    // ----
    // END: Acessibility Functions (ARIA)
    // ----

    // ----
    // START: Article Page: UserComment.cshtml
    // ----
    ns.articleUserComments = function (isSplitView) {

        isSplitView = isSplitView === true;

        var $commentModalSpinner = $('.comment-form__modal .preloader-wrap'),
            $commentFormError = $('.content-form__response--error');

        $('#comment-modal-opener' + (isSplitView ? '-sv' : '')).click(function (e) {
            e.preventDefault();
            var lastActiveElement = $('#comment-modal-opener');
            if (SCM.UserCommentView.isUserLoggedIn !== 'True') {
                var returnUrl = SCM.JSUtility.getSearchParamByName('returnUrl');
                if (returnUrl === undefined || returnUrl === null) {
                    returnUrl = location.pathname + location.search;
                }
                window.location = '/sign-in?returnUrl=' + encodeURIComponent(returnUrl);
            } else {
                resetCommentForm();
                $.ajax({
                    url: (App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '') + '/Content/SelfServeContent',
                    type: 'GET',
                    data: {
                        selfServeContentId: 'CommentsTermsAndConditions',
                        selfServeVersionId: 0
                    }
                }).done(function (data) {
                    showTermsAndConditions(data);
                    var modal = $('#divCommentModal');
                    setTimeout(function () {
                        modal.attr('tabindex', '-1').focus();
                    }, 1000);//wait for animation to complete

                    var closeBtn = $('.icon-general-close');

                    SCM.trapFocus.publicTrapFocus(modal, closeBtn, lastActiveElement);
                });

            }
        });

        $('#btnUserAgreeTerms').click(function (e) {
            e.preventDefault();
            if (validateTermsCheckbox()) {
                $('#TermsAndConditionsContainer, #termsAgreeRow, #termsButtonRow').hide();
                $('#divUserCommentForm').show();

                var modal = $('#divCommentModal');
                var closeBtn = $('.icon-general-close');
                var lastActiveElement = $('.comment-body__button');
                modal.attr('tabindex', '-1').focus();

                SCM.trapFocus.publicTrapFocus(modal, closeBtn, lastActiveElement);
            }
        });


        $('#divCommentModal .btnUserCommentSubmit').click(function (e) {
            e.preventDefault();
            //Validate Form and Submit
            if (validateCommentForm()) {
                //$('.pleaseWait').show(); // INSTEAD OF THIS, USE PRELOADER/SPINNER
                $commentModalSpinner.removeClass('hide');
                submitCommentValues();
                $('#divCommentModal').attr('tabindex', '-1').focus();

            }
        });


        $('#divCommentModal .btnModalCancel, #divCommentModal .btnCommentModalExit, .comment-form__close').click(function (e) {
            e.preventDefault();
            $('#divCommentModal').foundation('reveal', 'close');
            $('#comment-modal-opener').focus();
        });


        $('input[name="NoConflicts"]').change(function () {
            if ($(this).is(':checked')) {
                $('.disclosureBox').show();
            } else {
                $('.disclosureBox').hide();
            }
        });

        function showTermsAndConditions (data) {
            $('#termsAgreeRow .lblTermsAndConditions.errors').hide();
            $('#TermsAndConditionsContainer').html(data);
            $('#TermsAndConditionsContainer, #termsAgreeRow, #termsButtonRow').show();
            $('#divCommentModal').foundation('reveal', 'open');
        }

        function validateTermsCheckbox() {

            var $termsCondition = $('#termsAgreeRow #termsAndConditionsCheckbox');

            if ($termsCondition.length && !$termsCondition.is(':checked')) {
                $('#termsAgreeRow .lblTermsAndConditions.errors').show();
                return false;
            }
            else {
                $('#termsAgreeRow .lblTermsAndConditions.errors').hide();
                return true;
            }
        }


        //Validate Form Data
        function validateCommentForm() {

            var isValid = false;

            resetCommentFormValidation();
            //Validate Form Using Validity Plugin
            $.validity.setup({ outputMode: 'label' });
            $.validity.start();
            $('#divCommentModal .required').require();

            var result = $.validity.end();

            // Enforce the comment textarea maxlength for none html5 browsers. @*it also would be nice to have a real time char counter*@
            var comment = $('#divUserCommentForm').find('textarea#Comment');
            var commentBody = comment.val();
            var commentBodyCharLimit = parseInt(comment.attr('maxlength'));
            if (commentBodyCharLimit > 0 && commentBody.length > commentBodyCharLimit) {
                commentBody = commentBody.substring(0, commentBodyCharLimit);
            }

            //Additional Validation required for Disclosure Input and Checkbox 
            if (SCM.UserCommentView.bShowDisclosure === 'true' && $('input[name="NoConflicts"]').is(':checked') && $('textarea[name="Disclosure"]').val() === '') {
                $('#divCommentModal .lbldisclosure.errors').show();
                isValid = false;
            } else {
                isValid = result.valid;
            }

            return isValid;
        }


        function resetCommentForm() {

            $('#divUserCommentForm').hide();
            var commentForm = $('#divCommentModal');
            commentForm.find('input, textarea').val('');
            commentForm.find('#displayAlert, div.captchaAlert').hide();
            $('input[name="NoConflicts"]').removeAttr('checked');
            $('#termsAndConditionsCheckbox').attr('checked', false);
            $('.disclosureBox').hide();
            $('#divCommentModal .btnCommentModalExit').hide();
            $('#recaptcha_reload').trigger('click');
            var authorInput = commentForm.find('#Author');
            authorInput.attr('value', authorInput.attr('dataauthorvalue'));
            resetCommentFormValidation();
        }


        //Clear Error Messages
        function resetCommentFormValidation() {

            var commentForm = $('#divCommentModal');

            commentForm.find('.error')
                .not('.lbldisclosure.errors')
                .remove();

            $commentFormError.hide();
            commentForm.find('.lbldisclosure.errors').hide();
            $('#termsAgreeRow .lblTermsAndConditions.errors').hide();
            $commentFormError.text('');
        }


        function submitCommentValues() {

            var commentForm = $('#divUserCommentForm');
            var resourceType = SCM.UserCommentView.resourceType;
            var resourceId = SCM.UserCommentView.resourceId;
            var affiliation = '';
            var disclosures = '';

            if (SCM.UserCommentView.showAffiliations === 'true') {
                affiliation = commentForm.find('input#AffInstitution').val();
            }

            if (SCM.UserCommentView.bShowDisclosure === 'true') {
                disclosures = commentForm.find('textarea#Disclosure').val();
            }

            $.ajax({
                type: 'POST',
                url: '/Content/SubmitUserComment',
                data: {
                    author: commentForm.find('input#Author').val(),
                    affInstitutions: affiliation,
                    disclosure: disclosures,
                    title: commentForm.find('input#Title').val(),
                    comment: commentForm.find('textarea#Comment').val(),
                    resourceType: resourceType,
                    resourceId: resourceId,
                    recaptchaChallege: $('#recaptcha_challenge_field').val(),
                    recaptchaResponse: $('#recaptcha_response_field').val(),
                    instanceName: SCM.UserCommentView.InstanceName
                },
                success: function (result) {
                    //$('.pleaseWait').hide();
                    $commentModalSpinner.addClass('hide');
                    if (result.Success === true) {
                        commentForm.hide();
                        $('#divCommentModal #displayAlert').show();
                        $('#divCommentModal .btnCommentModalExit').show();

                        //For clients that don't moderate comments (such as ASHA)...
                        //they want to refresh page after comment is submitted so that the new comment appears.
                        //For clients that do moderate comments (such as ASA)...
                        //we don't want to refresh the page so that the user can see the Success modal.

                        if (SCM.UserCommentView.isNotModerated.toLowerCase() === 'true') {
                            location.reload();
                        }

                    } else {
                        $commentModalSpinner.addClass('hide');
                        $('div.captchaAlert').show();
                    }
                },
                error: function (evt) {
                    // NARN-11087 as a special case, if we get a 401, we assume the user isn't allowed anymore, and we redirect to the sign on page
                    if (evt.status === '401') {
                        $commentFormError.html('You must be logged in to submit a comment.');
                        window.location = '/sign-in?returnUrl=' + encodeURIComponent(window.location.pathname + window.location.search);
                    }
                    else {
                        $commentFormError.html('Comments not saved. Please Try Again.');
                    }

                    $commentModalSpinner.addClass('hide');

                    $commentFormError.show();
                }
            });
        }
    };
    // ----
    // END: Article Page: UserComment.cshtml
    // ----

    // ----
    // Initialization functions
    // ----
    ns.init = function () {
        ns.detectIfFirefox();
        ns.initSkipNavToMainContent();
        ns.articleUserComments();
        ns.closeNavbarSearch();
        ns.expandNavbarSearch();
        ns.initAriaControls();
        ns.initFilterClickEvent();
        ns.initSearchResultsSort();
        ns.initFoundation();
        ns.initLazyLoad();
        ns.showAuthorInfo();
        SCM.ChapterAnswerSet.registerAnswerLinkClick();
        ns.showFullAuthorList();
        ns.addAuthorFootnote();
        ns.showHideDropDown();
        ns.showRelatedBookWidgetIfHasContent();
        ns.showMoreRelatedContent('.grw-viewmorelink', '.grw-hide-me');
        ns.showMoreRelatedContent('.mrw-viewmorelink', '.mrw-hide-me');
        ns.showSpinner();
        ns.toggleMobileLanguageSubmenu();
        ns.toggleMobileMenu();
        SCM.SiteJS.toggleMobileSignInForm();
        SCM.NavDropdown.registerNavDropdownEvents(); // site level nav
        ns.toggleMobileSearch();
        ns.toggleResponsiveLeftColumn(); // renamed
        SCM.PubHistory.registerToggle();
        SCM.PeerReview.registerToggle();
        ns.restrictedImages();
        ns.moveSubmitCommentLink();
        ns.addAuthorNotesJumpLink();
        ns.addDataSupplementsJumpLink();
        ns.addDataRepositoriesJumpLink();
        ns.addUserCommentJumpLink();
        ns.oupHeaderDropdowns();
        ns.initSigninForm(); // AJAX
        ns.setAllLinksTarget();
        ns.showPdfOnlyLink();
        ns.setBlockLink();
        ns.showFullDisclaimer();
        ns.showFullVersionInfo();
        ns.handleUnresolvedRelatedObjectLinks();
        SCM.BookPartTitleFacet.init();
        SCM.CollectionFacet.init();
        SCM.ChapterEndNotes.init();
        SCM.ContentMetric.init();
        SCM.SeamlessAccess.init();
        SCM.SearchAccessibility.init();
        App.OUPSeamlessAccess.init();
        App.OUPShibboleth.init();
        SCM.ViewLarge.registerMousePointer();
        App.NavigationMenu.init();
        App.TreeListNavigation.init();
        App.ExportTitleList.init();
        App.OrcidId.init();
        App.JournalAlertsSignUp.init();
        App.TableOverflow.init();
        App.AlertsSignUp.init();
        App.AlertsAccessibility.init();
        App.SubsidiaryCollectionFrontMatter.init();
        SCM.DynamicDiscovery.init();
        SCM.FocusRestore.init();
        SCM.GiftAccessModals.init();
    };

    ns.windowLoadInit = function () {
        ns.revealFigsTablesInModal();
        ns.revealFeaturedFigureInModal();
        SCM.CitationModal.registerCitationModalEvents('getCitation');
        ns.launchSupersededContentModal();
        ns.setSelectedSearchFilter();
        ns.getNewSelectedFilter();
        ns.loadAllImagesIfUserIsAboutToUseJumpLinks();
        ns.showUnAuthenticatedSpans();
        ns.toggleSearchResultsDetails();
    };

    ns.initArticleTopInfoAccessOptions = function () {
        // e.g. /acn
        var siteName = window.location.pathname.substring(0, window.location.pathname.indexOf('/', 2));
        var signInUrl = siteName + '/sign-in?returnUrl=' + encodeURIComponent(window.location.pathname + window.location.search);

        var $options = $('.article-top-info-user-restricted-options');

        $options.find('.article-top-info-sign-in').attr('href', signInUrl);

    };


})(SCM.SiteJS = SCM.SiteJS || {}, jQuery);

// ----
// Where all modules get initialized
// ----
// A closure around doc.ready, window.load, window resize, and Ajax Complete so we can safely use $
(function ($) {
    var $resizeTimer,
        $pageColumnLeft = $('.page-column--left'),
        $micrositeSearch = $('.microsite-search'),
        $mobileSearchDropdown = $('.mobile-search-dropdown'),
        $navbarMenu = $('.navbar-menu, .navbar-search-collapsed'),
        $navbarSearchElements = $('.navbar-search-advanced, .navbar-search-close, .navbar-search'),
        viewportWidth = SCM.SiteJS.getViewportWidth();

    // all functions contained within the the resize & scroll events should be throttled or debounced in some way.
    // Example in SCM.JSUtility.js;

    // set z-index for page navigation (Article, Search Results, Issue TOC)
    var setMobileClass = function () {
        SCM.SiteJS.getViewportWidth() <= 1023 ? $pageColumnLeft.addClass('mobile') : $pageColumnLeft.removeClass('mobile');
    };

    // Window Resize Event
    $(window).on('resize', function () {
        clearTimeout($resizeTimer);
        $resizeTimer = setTimeout(function () {
            setMobileClass();

            var newWidth = SCM.SiteJS.getViewportWidth();

            // fire re-size events ONLY if the width changes
            // this check is for mobile browsers (Chrome, Safari), which have resizing toolbars
            if (viewportWidth !== newWidth) {

                // reset mobile site nav when going to desktop
                if (viewportWidth >= 1023) {
                    $('.dropdown-panel, .site-menu').removeAttr('style');
                }

                if (!$pageColumnLeft.hasClass('js-filters-open')) {
                    //reset mobile on search results & article pages
                    $(document.body).removeClass('noscroll');
                    $pageColumnLeft.hide();
                    $('.responsive-issue-nav').hide();
                    $('.page-column--left, .responsive-issue-nav, .issue-dropdown-wrap').removeAttr('style');

                    viewportWidth = SCM.SiteJS.getViewportWidth(); // record the new width, if it changed
                } else if (viewportWidth < newWidth && newWidth > 1023) {
                    // This is an additional case where, like in the above code, we drop noscroll
                    // but do not perform the other actions. In other cases, we don't want to drop the noscroll.
                    $(document.body).removeClass('noscroll');
                }

                // unhide collapsible navbar search if resizing above/below the range in which it is active
                if (viewportWidth <= 930 || viewportWidth >= 1101) {
                    $navbarMenu.removeAttr('style');
                    $navbarSearchElements.removeAttr('style');
                    //This is related to functions above: closeNavbarSearch and expandNavbarSearch.
                    $('.js-navbar-search-container').removeClass('tablet-viewport-active')
                        .addClass('tablet-viewport-layout');
                }

                // mobile search needs to be disabled above 930
                if (viewportWidth >= 931) {
                    $mobileSearchDropdown.removeAttr('style');
                    $micrositeSearch.removeAttr('style');
                    $('.dropdown-panel-wrap').children('.is-active').hide().removeClass('is-active');
                    $('.mobile-dropdown-toggle').removeClass('is-active');
                }
            }
            if ($('.al-author-info-wrap.open:visible').length && $('#ContentColumn:visible').length) {
                var $authorCard = $('.al-author-info-wrap.open');
                if ($(window).width() < 1200) {
                    var $contentColumn = $('#ContentColumn');
                    var columnRightEdge = $contentColumn.position().left + $contentColumn.width();
                    SCM.SiteJS.shiftOpenAuthorCards($authorCard, columnRightEdge);
                } else {
                    // if we're not in semi-mobile view where right rail goes to the bottom, put 
                    // cards back where they belong
                    $authorCard.removeClass('shift-card');
                }
            }

        }, 10); // in milliseconds

        // check for height of subject dropdown
        SCM.TreeBrowse.checkPageHeightForSeriesDropdown();
    });

    // Listen for orientation changes; some browswers use resize instead
    window.addEventListener('orientationchange', function () {
        var scrollOffset = $(window).scrollTop();

        $('body').animate({
            scrollTop: scrollOffset
        }, 0);
    }, false);

    // Window Load Event: Images done loading
    $(window).on('load', function () {
        SCM.SiteJS.windowLoadInit();
        SCM.SiteJS.adjustRelatedTagsDisplay();
        SCM.LazyLoadAd.init();
    });

    // Document Ready Event: DOM fully loaded
    $(function () {
        SCM.Logging.init();
        SCM.JqueryMigrateLogger.init();
        App.SolrFacet.init();
        setMobileClass();
        SCM.SiteJS.init(); // init general JS module for site
        SCM.Toolbar.init(); // init Toolbar module from client.toolbar.js
        SCM.PDFAccess.init(); // init PDF module from scm.sharedcontrols.pdfaccess.js
        SCM.SiteJS.setAccessIcons();
        SCM.StickyElements.init();
        SCM.AddReturnUrlToSocietyLinks();
        SCM.SiteJS.triggerSaveSearchModelOnRedirect();
        SCM.JumpLinks.init();
        SCM.RefLinks.init();
        SCM.Modals.init();
        if (window.matchMedia('print') && $('.video-js').length) {
            SCM.Utilities.Brightcove.init();
        }

        $('.custom-scroll').jScrollPane();
        if ($('.widget-ArticleFulltext').length > 0) {
            SCM.ArticleFulltext.init();
        }

        if ($('.widget-BookChapterMainView').length > 0) {
            SCM.BookChapterMainView.init();
        }
        SCM.BookMetadata.init();
        SCM.SplitScreen.init();
        SCM.ScholarlyiQ.init();
        SCM.TreeBrowse.init();
        SCM.LoginBox.init();
        SCM.CustomQueryBuilder.init();
        SCM.Interstitial.init();
        Theme.ArticleAbstract.init();
        Theme.BookAbstract.init();
        Theme.ChapterAbstract.init();
        Theme.CookiePro && Theme.CookiePro.loadCookiesIfNotEnabled && Theme.CookiePro.loadCookiesIfNotEnabled();
        Theme.BookSectionEditors.init();

        if ($('.widget-TrendMD').length) {
            SCM.SharedWidgets.TrendMD.init();
        }
    });

    // Ajax Complete Event
    $(document).ajaxStart(function () {
        $('body').css('cursor', 'wait');

    }).ajaxComplete(function (event, xhr, settings) {
        // init foundation for new DOM elements after new HTML loaded through AJAX
        SCM.SiteJS.initFoundation();
        SCM.SiteJS.initSearchResultsSort();
        SCM.SolrSearch.ajaxComplete();
        SCM.SiteJS.setAccessIcons();
        SCM.SiteJS.setAllLinksTarget();
        SCM.SiteJS.toggleResponsiveLeftColumn();
        $('body').css('cursor', 'default');
        SCM.SiteJS.abstractMathJax();
        // Need to do this to prevent recursion...
        if (settings.url.indexOf('brightcove') < 0 && !window.matchMedia('print')) {
            SCM.Utilities.Brightcove.init();
        }
        SCM.TreeBrowse.checkPageHeightForSeriesDropdown();
        SCM.Interstitial.DisableTriggerOnExternalLinks();
        SCM.CustomQueryBuilder.init();
    });

})(jQuery);